import { ConfirmOTP, resendNewOTP, accountExist, CompleteProfile, signUp } from "../api";
import { request, success, failure, SIGN_UP_REQUEST } from "./utilities";




export function userAccountExist(data) {
    return (dispatch) => {
        dispatch(request(SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_REQUEST));
        accountExist(data).then((res) => {
            if (res.data.status === 200) {
                dispatch(success(SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_SUCCESS, res.data.data));

            }
            else {
                dispatch(failure(SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_FAILURE, res.data.message));
            }
        }, (error) => {
            dispatch(failure(SIGN_UP_REQUEST.CHECK_EXIST_ACCOUTN_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function resendNewOtp(data, Notification) {
    return (dispatch) => {
        dispatch(request(SIGN_UP_REQUEST.RESEND_OTP_REQUEST));
        resendNewOTP(data).then((res) => {
            if (res.data.status === 200) {
                dispatch(success(SIGN_UP_REQUEST.RESEND_OTP_SUCCESS, res.data.data));
                if (Notification) Notification(res.data.message, "success")
            }
            else {
                dispatch(failure(SIGN_UP_REQUEST.RESEND_OTP_FAILURE, res.data.message));
                if (Notification) Notification(res.data.message, "error")
            }
        }, (error) => {
            dispatch(failure(SIGN_UP_REQUEST.RESEND_OTP_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function confirmOTP(data, completeProfile, Notification) {
    return (dispatch) => {
        dispatch(request(SIGN_UP_REQUEST.CONFIRM_OTP_REQUEST));
        ConfirmOTP(data).then((res) => {
            if (res.data.status === 200) {
                dispatch(success(SIGN_UP_REQUEST.CONFIRM_OTP_SUCCESS, res.data.data));
                if (completeProfile) completeProfile();
            }
            else {
                dispatch(failure(SIGN_UP_REQUEST.CONFIRM_OTP_FAILURE, res.data.message));
                if (Notification) Notification(res.data.message, "error")
            }
        }, (error) => {
            dispatch(failure(SIGN_UP_REQUEST.CONFIRM_OTP_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function completedProfile(data, Notification, moveToNext) {
    return (dispatch) => {
        dispatch(request(SIGN_UP_REQUEST.COMPLETE_PROFILE_REQUEST));
        CompleteProfile(data).then((res) => {
            if (res.data.status === 200) {
                dispatch(success(SIGN_UP_REQUEST.COMPLETE_PROFILE_SUCCESS, res.data.data));
                if (Notification) Notification(res.data.message, "success")
                if (moveToNext) moveToNext()
            }
            else {
                dispatch(failure(SIGN_UP_REQUEST.COMPLETE_PROFILE_FAILURE, res.data.message));
                if (Notification) Notification(res.data.message, "error")
            }
        }, (error) => {
            dispatch(failure(SIGN_UP_REQUEST.COMPLETE_PROFILE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}

export function signUpProfile(data, moveToOTPSide, Notification) {
    return (dispatch) => {
        dispatch(request(SIGN_UP_REQUEST.SIGN_UP_PROFILE_REQUEST));
        signUp(data).then((res) => {
            if (res.data.status === 200) {
                dispatch(success(SIGN_UP_REQUEST.SIGN_UP_PROFILE_SUCCESS, res.data.data));
                if (moveToOTPSide) moveToOTPSide()
                if (Notification) Notification(res.data.message, "success")
            }
            else {
                dispatch(failure(SIGN_UP_REQUEST.SIGN_UP_PROFILE_FAILURE, res.data.message));

                if (Notification) Notification(res.data.message, "error")
            }
        }, (error) => {
            dispatch(failure(SIGN_UP_REQUEST.SIGN_UP_PROFILE_FAILURE, (error && error.response && error.response.data && error.response.data.title ? error.response.data.title : error.message)))
        })
    }
}


